import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { NavigationExtras, Route, Router, UrlTree } from '@angular/router';
import { RedirectService } from './portal/redirect.service';

@Injectable()
export class CustomRouter extends Router {
  private isOldPortal: boolean;
  private appRoutes: string[];

  constructor(
    location: Location,
    private redirectService: RedirectService,
  ) {
    super();
    this.isOldPortal = location.path().startsWith('/legacy');
    this.appRoutes = this.getAppRoutes(this.config);
  }

  navigateByUrl(url: string | UrlTree, extras?: NavigationExtras): Promise<boolean> {
    return super.navigateByUrl(url, extras);
  }
  private getMigratedRoutes(url: string): Record<string, boolean> {
    let routes: Record<string, boolean> = {};
    this.appRoutes.forEach(route => {
      routes[route] = true;
    });
    return routes;
  }
  private getAppRoutes(routes: Route[]): string[] {
    let routePaths: string[] = [];

    routes.forEach(route => {
      if (route.children) {
        routePaths = routePaths.concat(route.children.map(childRoute => childRoute.path!));
      }
    });
    routePaths.push('');
    return routePaths;
  }

  private isMigratedRoute(url: string | UrlTree): boolean {
    let route: string;

    if (typeof url === 'string') {
      route = url;
    } else if (url instanceof UrlTree) {
      route = url.toString();
    } else {
      return false;
    }

    let startRoute = '';
    if (route.split('/').length > 1) {
      startRoute = route.split('/')[1].split('#')[0];
    } else {
      startRoute = route.split('#')[0];
    }

    return this.getMigratedRoutes(route)[startRoute] || false;
  }
  //   private validateGoalRoute(url: string): boolean {
  //     if (url.includes('edit') || url.includes('start') || url.includes('invest')) {
  //       return false;
  //     }
  //     return true;
  //   }
}
